import React from "react";
import { Row, Steps } from "antd";
import styled from "@emotion/styled";
import { CheckOutlined } from "@ant-design/icons";
import COLORS from "common/Colors";
const { Step } = Steps;
const Styleddiv = styled(Row)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img,
  svg {
    vertical-align: unset;
    font-size: 35px;
    background: ${COLORS.SIDEBAR};
    border-radius: 50px;
    border: 1px solid ${COLORS.TEXT.SECONDARY} ;
    padding: 8px;
  }
  .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
    // margin-top: 10px;
  }
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
    margin-top: 0px;
    color: #000;
  }
  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
    // margin-top: 10px;
    color: #000;
  }
  .ant-steps-item-process .ant-steps-item-icon {
    border-color: #000;
}
  .icon-color {
    color: #000;
  }
  .ant-steps {
    /* width: 450px; */
    box-sizing: border-box;
    margin: 0;
    padding: 10px;
    margin-left: 5%;
    margin-right: 5%;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-variant: tabular-nums;
    /* line-height: 1.5715; */
    list-style: none;
    font-feature-settings: 'tnum';
    display: flex;
    font-size:0;
    font-weight: 500;
    text-align: initial;
}

  .ant-steps-item-process .ant-steps-item-icon {
    background-color: ${COLORS.SIDEBAR};
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon .ant-steps-icon {
    color: #000;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color:#000;
}
/* .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: #26A4FF;
    font-size: 16px;
    font-weight: bold;
  } */
`;
const StepsProgress = ({ step, stepdata }) => {
  return (
    <>
      <Styleddiv className="">
        <Steps current={step} labelPlacement="vertical">
          {stepdata.map((item, index) => (
            <Step
              title={item.title}
              key={item.title}
              icon={
                step > index ? <CheckOutlined className="icon-color" /> : null
              }
            />
          ))}
        </Steps>
      </Styleddiv>
    </>
  );
};
export default StepsProgress;
